export const openGroupSelectorDialog = (node) => ({
    type: 'GROUP_SELECTOR_DIALOG__OPEN',
    node,
});
export const closeGroupSelectorDialog = () => ({
    type: 'GROUP_SELECTOR_DIALOG__CLOSE',
});
